import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const CollectionOfPersonalData = () => {
  return (
    <>
      <Subtitle>Collection of Personal Data</Subtitle>
      <Paragraph>
        Glints may collect personal information and/or data about you, such as
        your name, login ID and password, address, email address, phone number,
        age, gender, date of birth, country of residence, nationality, education
        level and work experience that is/are not otherwise publicly available.
        Occasionally, Glints may also collect additional personal information
        and/or data from you in connection with contests, surveys, or special
        offers.
      </Paragraph>
      <Paragraph>
        Only duly authorized staff of Glints will be permitted to access your
        personal information and data, and Glints shall not release such
        personal information and data to any third parties save except in the
        circumstances listed under the section headed “Disclosure or Transfer of
        Data” below.
      </Paragraph>
    </>
  );
};
